// Fun drawing facts — shared by the in-app FactsPage and the prerendered
// /drawing-facts/ SEO page (scripts/seo-pages.mjs), so the two never drift.

/** Short, fun, picture-first facts about drawing. */
export const DRAWING_FACTS: { emoji: string; text: string }[] = [
  { emoji: "🦣", text: "The oldest drawings are over 40,000 years old — made in caves!" },
  { emoji: "🖐️", text: "Leonardo da Vinci could draw with one hand and write with the other at the same time!" },
  { emoji: "🧠", text: "Doodling helps your brain remember things better." },
  { emoji: "🖍️", text: "The first box of crayons was sold over 100 years ago." },
  { emoji: "🎨", text: "There's no wrong way to draw — every artist has their own style!" },
  { emoji: "✏️", text: "One pencil can draw a line about 35 miles long!" },
  { emoji: "🟣", text: "Mix red and blue and you get purple. Try it!" },
  { emoji: "🚀", text: "Astronauts have drawn pictures up in space!" },
  { emoji: "🌈", text: "A rainbow has 7 colors — use every crayon!" },
  { emoji: "🐙", text: "An octopus can change its color, like it's drawing on itself." },
  { emoji: "👶", text: "Babies love to scribble — it's how they start learning to draw!" },
  { emoji: "🖌️", text: "The first paintbrushes were made from animal hair and twigs." },
  { emoji: "🔵", text: "Mix blue and yellow and you get green — like magic!" },
  { emoji: "🐘", text: "Some elephants can hold a brush with their trunk and paint!" },
  { emoji: "📏", text: "Drawing shapes like circles and squares helps you draw anything." },
  { emoji: "🌙", text: "Artists drew maps of the Moon long before anyone went there." },
  { emoji: "🐝", text: "Bees see colors we can't — they'd draw with secret crayons!" },
  { emoji: "👀", text: "Looking carefully at things helps you draw them better." },
  { emoji: "🦖", text: "We know what dinosaurs might look like thanks to artists' drawings." },
  { emoji: "❤️", text: "Drawing for someone you love is the best kind of gift." },
];
